export enum TrainingType {
    Recurring = "RECURRING"
}
